exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".cancel-offer-modal .treat-box[data-v-33a9afdf] {\n  padding: 2em 1.1em 3em;\n  margin: 3em auto 3.5em;\n  max-width: 21.5em;\n  background-color: #f6f5f4;\n  border-left: 8px solid #7ca3dc;\n}\n.cancel-offer-modal .treat-box svg[data-v-33a9afdf] {\n  height: 2.5em;\n}\n.cancel-offer-modal .treat-box .treat-text[data-v-33a9afdf] {\n  padding-top: 0.3em;\n}\n@media only screen and (min-width: 0px) and (max-width: 559px) {\n.cancel-offer-modal .treat-box[data-v-33a9afdf] {\n    max-width: 19.5em;\n}\n}\n", ""]);

// exports
